jQuery(document).ready(function (dolladollaBillYall) {
  $ = dolladollaBillYall;
 
  function initializeScrollbarSwipers() {
    $(".horizontal-scroll").each(function (index, element) {
      if (!$(element).hasClass("swiper-initialized")) {
        new Swiper(element, {
          direction: "horizontal",
          loop: false,
          slidesPerView: "auto",
          spaceBetween: 0,
          freeMode: true,
          navigation: {
            nextEl: $(element).find('.swiper-button-next')[0], // Or '.my-custom-next-arrow' if outside
            prevEl: $(element).find('.swiper-button-prev')[0], // Or '.my-custom-prev-arrow' if outside
          },
          scrollbar: {
            el: $(element).find(".swiper-scrollbar")[0],
            draggable: true,
          },
        });
      }
    });
  }

  initializeScrollbarSwipers();
  initVideoPopups();
  initInlineVideos();
});

function initVideoPopups() {
  var $videoSrc;
  var $videoType;

  $(".lazy-load-video").on("click", function (e) {
    // If user is/was swiping, block this click

    let iframe_src = $(this).attr("data-embed");
    let media_src = $(this).attr("data-media");

    if (iframe_src) {
      //add autoplay to the video if it is not already there
      if (iframe_src.indexOf("autoplay") == -1) {
        iframe_src += "&autoplay=1";
      }
      $videoSrc = iframe_src;
      $videoType = "embed";
    } else if (media_src) {
      $videoSrc = media_src;
      $videoType = "media";
    }
  });
  $(document).on("show.bs.modal", "#videoModal", function (e) {
    if ($("body").hasClass("swiper-is-swiping")) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  });
  $(document).on("shown.bs.modal", "#videoModal", function (e) {
    if ($videoType === "embed") {
      $("#video_iframe").show();
      $("#video_player").hide();
      $("#video_iframe").attr("src", $videoSrc);
    } else if ($videoType === "media") {
      $("#video_iframe").hide();
      $("#video_player").show();
      $("#video_player").attr("src", $videoSrc);
      $("#video_player")[0].play();
    }
  });

  $("#videoModal").on("hide.bs.modal", function (e) {
    if ($videoType === "embed") {
      $("#video_iframe").attr("src", "");
    } else if ($videoType === "media") {
      $("#video_player")[0].pause();
      $("#video_player").attr("src", "");
    }
  });
}

function initInlineVideos() {
  $(document).on("click", ".inline_video", function () {
    let iframe_src = $(this).attr("data-embed");
    if (iframe_src) {
      if (iframe_src.indexOf("autoplay") == -1) {
        iframe_src += "&autoplay=1";
      }
      //create iframe and append it to the parent div
      let iframe = document.createElement("iframe");
      iframe.src = iframe_src;
      iframe.frameborder = 0;
      iframe.allow =
        "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture";
      iframe.allowfullscreen = true;
      iframe.width = "100%";
      iframe.height = "100%";
      iframe.onload = function () {};
      $(this).append(iframe);
      $(this).off("click");
      $(this).find(".video-preview").remove();
    }
  });
}

(() => {
  var lastScrollTop = 0;

  window.addEventListener(
    "scroll",
    function () {
      var st = window.pageYOffset || document.documentElement.scrollTop;

      const header = document.querySelector(".js-header");

      const subnav = document.querySelectorAll(".subnav");


      let isSubnavStuck = false;
      if (subnav) {
        subnav.forEach((el) => {
          if (el.classList.contains("is-stuck")) {
            isSubnavStuck = true;
          }
        });
      }

      // Handle 'at-top' state 
      if ($(window).scrollTop() > 0) {
        if (header) header.classList.remove("at-top");
      } else {
        if (header) header.classList.add("at-top");
      }

      // --- SCROLL DIRECTION LOGIC ---
      if (st > lastScrollTop) {
        // SCROLLING DOWN
        if (header) {
          header.classList.add("down");
          header.classList.remove("up");
          header.style.top = `-${header.offsetHeight}px`; // Hide Main Nav
          
          if (subnav) {
            subnav.forEach((el) => {
              el.classList.add("down");
              el.classList.remove("up");
            });
          }
        }
      } else if (st < lastScrollTop) {
        // SCROLLING UP
        if (!isSubnavStuck) {
            if (header) {
              header.classList.remove("down");
              header.classList.add("up");
              header.style.top = ""; // Show Main Nav
              
              if (subnav) {
                subnav.forEach((el) => {
                  el.classList.remove("down");
                  el.classList.add("up");
                });
              }
            }
        }
      } 
      
      lastScrollTop = st <= 0 ? 0 : st;
    },
    false
  );
})();
